import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import Countdown from '../countdown/countdown';
import { MILLISECONDS } from '../../../common/utils/date';
import { buildUrl } from '../../../common/utils/url/build-url';
import { openPopup } from '../../../common/utils/open-popup';
import classnames from 'classnames';
import styles from './live-label.scss';
import ScheduledIcon from '../../../icons/compiled/components/ScheduledIcon';
import InlineIcon from '../inline-icon/inline-icon';
const defaultDateFormat = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit'
};
const toShortISOWithoutDelimiters = datetime => new Date(datetime).toISOString().replace(/-|:|\.\d+/g, '');
export default class LiveLabel extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "openGoogleCalendarEvent", e => {
      const {
        startTime,
        liveText,
        videoTitle
      } = this.props;
      const startTimeShortISO = toShortISOWithoutDelimiters(startTime);
      const url = buildUrl('https://www.google.com/calendar/event', {
        action: 'TEMPLATE',
        dates: startTimeShortISO + "/" + startTimeShortISO,
        text: videoTitle,
        location: '',
        details: liveText
      });
      openPopup(url);
      e.stopPropagation();
    });
  }
  renderReminder() {
    const {
      reminderIcon,
      noBackground,
      reminderAriaLabel,
      isRTL
    } = this.props;
    if (!reminderIcon) {
      return null;
    }
    const styleName = classnames(styles.reminder, {
      [styles['no-bckg']]: noBackground,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("button", {
      onClick: this.openGoogleCalendarEvent,
      tabIndex: 0,
      role: "link",
      className: styleName,
      "aria-label": reminderAriaLabel
    }, reminderIcon);
  }
  renderLiveStreamLabel() {
    const {
      isSmall,
      className,
      liveText,
      isRTL
    } = this.props;
    const styleNames = classnames(styles['live-label'], className, styles['live-stream-label'], {
      [styles.small]: isSmall,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "live-stream-label",
      className: styleNames,
      role: "note",
      "aria-label": liveText
    }, liveText);
  }
  renderPendingLiveStreamLabel() {
    const {
      isSmall,
      className,
      pendingLiveText,
      isRTL
    } = this.props;
    const styleNames = classnames(styles['live-label'], className, styles['live-stream-label'], styles['live-stream-pending-label'], {
      [styles.small]: isSmall,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "live-stream-pending-label",
      className: styleNames,
      role: "note",
      "aria-label": pendingLiveText
    }, pendingLiveText);
  }
  mapPropsToStyles() {
    const {
      isRTL,
      noBackground,
      className
    } = this.props;
    const liveTextStyle = classnames(styles['live-text'], {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const textStyle = classnames(styles['live-scheduled-label'], {
      [styles['no-bckg']]: noBackground,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const soonLabelStyle = classnames(styles['live-label'], className, {
      [styles['no-bckg']]: noBackground,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const scheduledLabelBigStyle = classnames(styles['live-label'], className, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const countdownStyle = classnames(styles.countdown, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return {
      liveTextStyle,
      textStyle,
      soonLabelStyle,
      scheduledLabelBigStyle,
      countdownStyle
    };
  }
  renderScheduledSoonLabel() {
    const {
      startTime,
      liveText,
      scheduledSoonAriaLabel,
      startsInAriaLabel
    } = this.props;
    const {
      liveTextStyle,
      textStyle,
      countdownStyle,
      soonLabelStyle: labelStyle
    } = this.mapPropsToStyles();
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "scheduled-soon-label",
      className: labelStyle,
      "aria-label": scheduledSoonAriaLabel
    }, /*#__PURE__*/React.createElement("div", {
      className: textStyle
    }, /*#__PURE__*/React.createElement("span", {
      className: liveTextStyle
    }, liveText + ':'), /*#__PURE__*/React.createElement(Countdown, {
      className: countdownStyle,
      until: startTime,
      titlePrefix: startsInAriaLabel,
      isFocusable: true
    })), this.renderReminder());
  }
  renderScheduledLabelSmall() {
    const {
      smallClassName,
      className,
      scheduledAriaLabel,
      isRTL
    } = this.props;
    const styleNames = classnames(styles['live-label'], className, smallClassName, styles['live-scheduled-icon'], {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "scheduled-icon",
      className: styleNames,
      role: "img",
      "aria-label": scheduledAriaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(ScheduledIcon, null)
    }));
  }
  renderScheduledLabelBig() {
    const {
      startTime,
      locale,
      liveText,
      scheduledAriaLabel,
      dateFormat
    } = this.props;
    const {
      liveTextStyle,
      textStyle,
      scheduledLabelBigStyle: labelStyle
    } = this.mapPropsToStyles();
    const formattedDate = new Date(startTime).toLocaleString(locale, dateFormat);
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "scheduled-label",
      className: labelStyle,
      "aria-label": scheduledAriaLabel,
      role: "region"
    }, /*#__PURE__*/React.createElement("div", {
      tabIndex: 0,
      role: "region",
      className: textStyle
    }, /*#__PURE__*/React.createElement("span", {
      className: liveTextStyle
    }, liveText + ':'), formattedDate), this.renderReminder());
  }
  render() {
    const {
      startTime,
      isSmall,
      isReadyLiveStream,
      isPendingLiveStream,
      isScheduled
    } = this.props;
    if (isPendingLiveStream) {
      return this.renderPendingLiveStreamLabel();
    }
    if (isReadyLiveStream) {
      return this.renderLiveStreamLabel();
    }
    if (isScheduled) {
      if (isSmall) {
        return this.renderScheduledLabelSmall();
      }
      return startTime - Date.now() < MILLISECONDS.ONE_DAY ? this.renderScheduledSoonLabel() : this.renderScheduledLabelBig();
    }
    return null;
  }
}
_defineProperty(LiveLabel, "defaultProps", {
  dateFormat: defaultDateFormat
});
//# sourceMappingURL=live-label.js.map